import type { Block } from "../../contract"
import { AskBack } from "./AskBack"
import { Checklist } from "./Checklist"
import { Deadline } from "./Deadline"
import { Decisions } from "./Decisions"
import { Disclosure } from "./Disclosure"
import { Exposure } from "./Exposure"
import { Limitation } from "./Limitation"
import { List } from "./List"
import { Note } from "./Note"
import { Para } from "./Para"
import { Quote } from "./Quote"
import { Table } from "./Table"
import { Tally } from "./Tally"
import { TurnsOn } from "./TurnsOn"
import { YourUse } from "./YourUse"

/** Render one block by type. `path` is a stable key for local state (ask_back, checklist). */
export function BlockView({ block, path }: { block: Block; path: string }) {
  switch (block.type) {
    case "para": return <Para text={block.text} cites={block.cites ?? []} />
    case "disclosure": return <Disclosure label={block.label} blocks={block.blocks ?? []} path={path} />
    case "quote": return <Quote {...block} />
    case "list": return <List ordered={block.ordered} items={block.items ?? []} />
    case "table": return <Table rows={block.rows ?? []} note={block.note ?? ""} />
    case "note": return <Note text={block.text} />
    case "ask_back": return <AskBack question={block.question} options={block.options ?? []} path={path} />
    case "tally": return <Tally {...block} cases={block.cases ?? []} />
    case "checklist": return <Checklist items={block.items ?? []} path={path} />
    case "your_use": return <YourUse for={block.for ?? []} against={block.against ?? []} path={path} />
    case "turns_on": return <TurnsOn items={block.items ?? []} />
    case "limitation": return <Limitation verdict={block.verdict} summary={block.summary} rows={block.rows ?? []} caveats={block.caveats ?? []} />
    case "decisions": return <Decisions lean={block.lean} items={block.items ?? []} none={block.none} />
    case "exposure": return <Exposure rows={block.rows ?? []} total={block.total} monthly={block.monthly_interest_inr} note={block.note} />
    case "deadline": return <Deadline label={block.label} date={block.date} basis={block.basis} />
    default: return null
  }
}

/** A run of blocks. Nested paths are `parent.i` so state keys never collide. */
export function Blocks({ blocks, path }: { blocks: Block[]; path?: string }) {
  return (
    <>
      {blocks.map((b, i) => {
        const p = path ? `${path}.${i}` : String(i)
        return <BlockView key={p} block={b} path={p} />
      })}
    </>
  )
}
